import { gridCols, gridMargin } from './constants';

/** Convert grid column units to pixel width. */
export function gridUnitsToPx(w: number, gridWidth: number): number {
  const colW = (gridWidth - gridMargin[0] * (gridCols + 1)) / gridCols;
  return colW * w + (w - 1) * gridMargin[0];
}

/** Convert pixel width to grid column units (rounded). */
export function pxToGridUnits(px: number, gridWidth: number): number {
  const colW = (gridWidth - gridMargin[0] * (gridCols + 1)) / gridCols;
  return Math.round((px + gridMargin[0]) / (colW + gridMargin[0]));
}
